<template>
  <el-dialog
    title="从其他模板复制题目"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="500px"
    @keyup.enter.native="onSubmit()"
    class="step-template-copy-question-to">
    <el-form :model="form"
             status-icon
             :rules="rules"
             ref="form"
             label-width="80px">
      <el-form-item label="来源模板"
                    prop="substep_id">
        <remote-select
          class="width-max"
          clearable
          id-key="id"
          label-key="title"
          value-key="id"
          placeholder="请输入分步任务模板关键字"
          v-model="form.fromId"
          :query-request="getStepTemplateTable"
          @change="changeTemplate">
        </remote-select>
      </el-form-item>
      <el-form-item label="来源题目"
                    prop="fromIndex"
                    class="el-select-multiple-tag-ellipsis">
        <el-select class="width-max"
                   v-model="form.fromIndex"
                   placeholder="请选择题目"
                   multiple
                   @change="changeQuestion"
                   :disabled="!form.fromId">
          <el-option
            v-for="(question, index) in fromQuestions"
            :key="index"
            :label="`Q${index+1} ${stripTags(question.title)}`"
            :value="index"
            :disabled="fixedIds.includes(question.id)">
            <div v-html="`Q${index+1} ${question.title}`"></div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="复制到"
                    prop="toIndex">
        <el-select class="width-max"
                   v-model="form.toIndex"
                   placeholder="请选择题目">
          <el-option
            v-for="(question, index) in toQuestions"
            :key="index"
            :label="`Q${index+1} ${stripTags(question.title)}`"
            :value="index"
            :disabled="fixedIds.includes(question.id)">
            <div v-html="`Q${index+1} ${question.title}`"></div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="onSubmit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { convertQuestions } from '@views/question-editor/format/convert'
import questionUtil from '@views/question-editor/utils/questions'

export default {
  components: {},
  inject: ['request'],
  props: {
    fixedIds: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      stripTags: filter.stripTags,
      loading: false,
      visible: false,
      rules: {
        fromIndex: [
          {required: true, message: '请选择来源题目', type: 'array', trigger: 'change'},
        ],
      },
      fromQuestions: [],
      toQuestions: [],
      form: {
        fromId: null,
        fromIndex: [],
        toIndex: null,
        questions: [],
      },
    }
  },
  computed: {},
  watch: {
    visible () {
      if (!this.visible) {
        Object.assign(this.$data, this.$options.data())
        this.$nextTick(() => this.$refs.form.clearValidate())
      }
    },
  },
  created () {},
  mounted () {},
  methods: {
    getStepTemplateTable (_) {
      return request(this.request.table, _)
    },
    getStepTemplateDetail (_) {
      return request(this.request.detail, _)
    },
    open (questions, callback = () => {}) {
      this.toQuestions = questions
      this.callback = callback
      this.visible = true
    },
    changeTemplate ({id}) {
      this.form.fromIndex = []
      this.getStepTemplateDetail({id}).then(({data}) => {
        this.fromQuestions = JSON.parse(data.json)
      })
    },
    changeQuestion (value) {
      this.form.fromIndex = _.sortBy(value)
    },
    resetId (questions) {
      questions.forEach((question) => {
        questionUtil.replaceId(questions, question.id)
      })
    },
    getForm () {
      // 获得选择的题目列表
      let questions = filter.copyJson(
        _.filter(
          convertQuestions(this.fromQuestions),
          (question, index) => this.form.fromIndex.includes(index)
        )
      )
      // 移除不存在的题目ID
      questionUtil.removeNonexistentTargetId(questions)
      // 重置题目的ID
      this.resetId(questions)
      this.form.questions = questions
      return this.form
    },
    onSubmit () {
      this.loading = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.callback(this.getForm())
          this.visible = false
        } else {
          this.$message.error('提交内容填写不正确！')
        }
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
.step-template-copy-question-to {
  .el-select-multiple-tag-ellipsis {
    .el-tag .el-select__tags-text {
      max-width: 280px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: top;
    }
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/CopyQuestionTo.vue